export class SystemConstants {
  public static melbourneLatitude = -37.8136;
  public static melbourneLongitude = 144.9631;
  public static defaultCountry = 'Australia';
  public static defaultMapZoom = 15;
  public static supportPhoneNumber = '1300 882 622';
  public static supportEmailAddress = 'support@campaignagent.com.au';
}
